import { ProgramDescriptionAccordion } from '@components/buzzkuri/shared/uiParts/accordion/ProgramDescription'
import { ProgramStep } from '@type/buzzkuri/program-detail'
import React from 'react'
import { StepItem } from './Item'

type Props = {
  steps: ProgramStep[]
}

export const ProgramStepSection = ({ steps }: Props): JSX.Element => {
  return (
    <div className="w-[87.2vw] lg:w-[62.6vw]">
      <ProgramDescriptionAccordion title="プログラムの流れ">
        <div className="px-[6.1vw] lg:px-[3.3vw] pt-[8vw] lg:pt-[3.4vw] pb-[10.6vw] lg:pb-[3.6vw] bg-[#F7F6F5]">
          {steps.map((step, stepNum) => (
            <div key={stepNum} className="mt-[4.2vw] first:mt-0 lg:mt-0">
              <StepItem {...{ step, stepNum }} />
            </div>
          ))}
        </div>
      </ProgramDescriptionAccordion>
    </div>
  )
}
